// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"f19c73dd","297":"f0337442","321":"fc0a3a39","329":"f0337442","628":"054a8b84","643":"054a8b84","681":"9d0777ee","838":"054a8b84"}[chunkId] + ".chunk.css";
};